var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M250 0C111.929 0 0 111.929 0 250s111.929 250 250 250 250-111.929 250-250S388.071 0 250 0zm134.386 364.952c-3.9 4.875-95.992-38.962-147.549-70.513-7.107 13.84-13.68 27.663-19.213 40.602-13.305 31.114-13.839 35.352-28.089 43.025-14.251 7.673-41.655 13.154-47.136 8.77-4.097-3.278 26.215-68.852 54.723-120.302-34.41-27.099-69.346-61.239-74.723-79.164-6.578-21.923-3.015-44.943 4.659-42.751 7.674 2.192 48.047 50.659 78.74 73.678 4.281 3.211 9.009 6.561 14.07 9.992 1.414-2.152 2.791-4.196 4.119-6.1 27.885-39.969 74.069-90.764 95.993-97.341 21.924-6.578 44.943-3.015 42.751 4.659-2.192 7.674-50.658 48.047-73.678 78.741-9.078 12.104-19.235 27.678-29.341 44.74 23.822 13.66 49.76 26.854 72.879 36.74 31.114 13.305 35.352 13.839 43.025 28.09 7.674 14.249 13.154 41.653 8.77 47.134z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.6ef61b3436ca56f737d58374791dba50.svg";
export { ForwardRef as ReactComponent };